// import { DurationUnit } from 'luxon'
import { LuxDuration } from '../timeF/Date1TimeF.mts';
import * as _ from 'lodash-es';
// type DurTypeStr = DurationUnit
const unitAbbrev = {
    days: 'd',
    hours: 'h',
    minutes: 'm',
    seconds: 's',
};
export const dur2Human = (luxonDiff) => {
    const sec = luxonDiff.as('seconds');
    return (sec < 0 ? '-' : '+') + secToHumanAbs(sec);
};
export const durHumanAbs = (luxonDiff) => {
    if (!luxonDiff)
        return luxonDiff;
    return secToHumanAbs(luxonDiff.as('seconds'));
};
export const secToHumanAbs = (durSec) => {
    if (durSec < 0) {
        durSec = Math.abs(durSec);
    }
    // const unitAbbrev = {
    //   days: 'notimportant',
    // }  
    // Duration.fromMillis(1000).as(Object.keys(unitAbbrev)[0] as DurTypeStr)
    const units = _.keys(unitAbbrev);
    for (let i = 0; i < units.length; i += 1) {
        const unit = units[i];
        const unitDurSec = LuxDuration.fromObject({ [unit]: 1 }).as('seconds');
        if (unitDurSec <= durSec) {
            const unitDur = _.round(LuxDuration.fromMillis(durSec * 1000).as(unit));
            const abbrev = unitAbbrev[unit];
            return `${unitDur}${abbrev}`;
        }
    }
    return '0s'; // Default return to handle edge case when no condition is met
};
